module.exports = __webpack_public_path__ + "img/icon-temp.b2c74428.svg";